export enum BriefStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
}
